import {CanActivateFn, Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {inject} from '@angular/core';

export const redirectGuard: CanActivateFn = (route, state) => {
  const oAuthService = inject(OAuthService);
  const router = inject(Router);

  const isRegisterComplete = decodeURIComponent(oAuthService.state || '') === '/register/(registeroutlet:complete)';
  if (!isRegisterComplete && (oAuthService.hasValidAccessToken() && !!oAuthService.state)) {
    // Extract the state and redirect and redirect to route
    const savedUrl = oAuthService.state;
    oAuthService.state = '';

    const decodedUrl = decodeURIComponent(savedUrl);
    const segments = [];
    let buffer = '';
    let parenLevel = 0;

    for (let i = 0; i < decodedUrl.length; i++) {
      const char = decodedUrl[i];
      if (char === '(') parenLevel++;
      if (char === ')') parenLevel--;
      if (char === '/' && parenLevel === 0) {
        if (buffer.length > 0) segments.push(buffer);
        buffer = '';
      } else {
        buffer += char;
      }
    }
    if (buffer.length > 0) segments.push(buffer);

    let outlet = '';
    let outletPath = '';

    for (let i = 0; i < segments.length; i++) {
      let testSeg = segments[i];
      if (testSeg.startsWith('(')) {
        testSeg = testSeg.replace(/[()]/g, '');
        outlet = testSeg.split(':')[0];
        outletPath = testSeg.split(':')[1];
      }
    }

    if (outlet.length > 0) {
      const primarySegments = segments.filter(s => !s.startsWith('(')).map(seg => {
      if (seg.includes(';')) {
        const [path, ...params] = seg.split(';');
        const paramObj = Object.fromEntries(params.map(p => {
          const [k, v] = p.split('=');
          return [k, v];
        }));
        return [path, paramObj];
      }
      return seg;
    }).flat();
      const outlets = { [outlet]: outletPath };
      return router.navigate([...primarySegments, { outlets }]);
    }

    const primarySegments = segments.filter(s => !s.startsWith('(')).map(seg => {
      if (seg.includes(';')) {
        const [path, ...params] = seg.split(';');
        const paramObj = Object.fromEntries(params.map(p => {
          const [k, v] = p.split('=');
          return [k, v];
        }));
        return [path, paramObj];
      }
      return seg;
    }).flat();

    return router.navigate(primarySegments)

  } else {
    return true;
  }
};
